import React from "react";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function FavoriteButton({ kind, refId, className = "", size = 18 }) {
  const { isFavorite, toggleFavorite } = useAuth();
  const active = isFavorite(kind, refId);

  const handle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const res = await toggleFavorite(kind, refId);
    if (res === true) toast.success("Saved to your favorites");
    else if (res === false) toast("Removed from favorites");
  };

  return (
    <span
      role="button"
      tabIndex={0}
      data-testid={`favorite-${kind}-${refId}`}
      onClick={handle}
      onKeyDown={(e) => (e.key === "Enter" ? handle(e) : null)}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-full border transition-all cursor-pointer ${
        active
          ? "bg-rose-50 border-rose-200 text-rose-500"
          : "bg-white border-slate-200 text-slate-400 hover:text-rose-500 hover:border-rose-200"
      } ${className}`}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
    >
      <Heart size={size} fill={active ? "#f43f5e" : "transparent"} />
    </span>
  );
}
